import React from "react";
import "./testimonial.css";
import { Container, Row, Col } from "reactstrap";
import Slider from "react-slick";

import img from "../../assests/images/testimonial01.png";

const Testimonials = () => {
  const settings = {
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
  };
  return (
    <section>
      <Container className="testimonial-main-container">
        <Row>
          <Col lg="10" md="12" className="m-auto">
            <div className="testimonial__wrapper d-flex justify-content-between align-items-center ">
              <div className="testimonial__img w-50">
                <img src={img} alt="" className="w-100 img-base-testimonial" />
              </div>

              <div className="testimonial__content w-50">
                <h2 className="mb-4">Python айырмашылығы</h2>

                <Slider {...settings}>
                  <div>
                    <div className="single__testimonial">
                      <h6 className="mb-3 fw-bold">
                        Python көптеген басқалардан айырмашылығы
                      </h6>
                      <p>
                        Python көптеген басқалардан айырмашылығы нақты бағдарламалау тілі ретінде оқылады.

                        Python түсіндіріледі, бұл бағдарламаны әзірлеу кезінде сізге көп уақытты үнемдеуге мүмкіндік береді, өйткені компиляция мен орналасу қажет емес.

                        Python-да командалық жол аудармашысы бар, сондықтан сіз Python тілінің мүмкіндіктерін пайдаланып, жылдам есептеулер жүргізе аласыз.

                        Python бағдарламалары C бағдарламаларына қарағанда тезірек жасалуы мүмкін, олар қысқа және оқуға оңай.
                      </p>

                      <div className="student__info mt-4">
                        <h6 className="fw-bold"></h6>
                        <p></p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="single__testimonial">
                      <h6 className="mb-3 fw-bold">
                        Дифференциалдық теңдеулер
                      </h6>
                      <p>
                        Дифференциалдық теңдеулер, мысалы: қарапайым жүйелердің тербелістері (серіппелі масса, маятник және т. б.), сұйықтық механикасы (Навье-Стокс, Лаплас және т. б.),

                        кванттық механика (Шредингер) және басқалары қарапайым немесе күрделі құбылыстарды модельдеу үшін қолданылады.

                        Python көмегімен біз сізге осы теңдеулерді сандық түрде қалай шешуге болатындығын көрсетеміз.
                      </p>

                      <div className="student__info mt-4">
                        <h6 className="fw-bold"></h6>
                        <p></p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="single__testimonial">
                      <h6 className="mb-3 fw-bold">
                        Mодельдеу арқылы жүйелер мен физикалық құбылыстар
                      </h6>
                      <p>
                        - Бұл модельдеу арқылы жүйелер мен физикалық құбылыстарды түсінуге көмектеседі.
                        Python көмегімен біз сізге осы теңдеулерді сандық түрде қалай шешуге болатындығын көрсетеміз.

                        Бұл сізге кез-келген эксперименттік деректерді талдауда Тәуелсіздік пен сенімділік береді.
                      </p>

                      <div className="student__info mt-4">
                        <h6 className="fw-bold"></h6>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Testimonials;
